import { render } from "./regions-list.vue?vue&type=template&id=354b1d6b"
import script from "./regions-list.vue?vue&type=script&lang=js"
export * from "./regions-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__